export class Bot {
  active: boolean = false;
  bot_id: string = '';
  description?: string;
  image?: string;
  name: string = '';
  username: string = '';
  settings: any;
  template: any;
  connections: any;
  links: any;
}

export class BotVariable {
  bot_id: string = '';
  name: string = '';
  title: string = '';
  type: string = '';
  value: any = '';
}

export class BotIntent {
  bot_id: string = '';
  intent_id: string = '';
  name: string = '';
  expressions: Array<any> = [];
  response: any;
}

export interface BotTeamMember {
  id: string;
  name: string;
}

export interface BotDateRange {
  from: Date | null;
  to: Date | null;
}
